import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

type TypegetCurrentSn = {
  token: string;
  id: string;
};

const IssueSN = async ({ token, id }: TypegetCurrentSn) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/sn/issue-note`,
      {
        structuredNoteId: id,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default IssueSN;
